import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import Style from './email-usage.module.scss';

const formatTime = value => new Intl.DateTimeFormat('es-EC', {
  timeZone: 'America/Guayaquil', day: '2-digit', month: 'short',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
}).format(new Date(value));

export function CampaignEmailUsage() {
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [clock, setClock] = useState(Date.now());
  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/user/campaign-email-usage');
      setUsage({ ...response.data.data, received_at: new Date().toISOString() });
      setError(false);
      setClock(Date.now());
    } catch (_) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, 60000);
    const ticker = setInterval(() => setClock(Date.now()), 1000);
    window.addEventListener('focus', refresh);
    return () => {
      clearInterval(interval);
      clearInterval(ticker);
      window.removeEventListener('focus', refresh);
    };
  }, [refresh]);
  // Base countdown on the server clock, even if the device's clock is wrong.
  const serverNow = usage ? new Date(usage.checked_at).getTime() + Math.max(0, clock - new Date(usage.received_at || usage.checked_at).getTime()) : clock;
  const retry = usage && usage.retry_at ? new Date(usage.retry_at).getTime() : null;
  const blocked = retry && retry > serverNow;
  const minutes = blocked ? Math.ceil((retry - serverNow) / 60000) : 0;
  return (
    <section className={Style.panel} aria-label='Uso de correo' aria-busy={loading}>
      <div className={Style.heading}>
        <h2>Uso de correo</h2>
        <button type='button' onClick={refresh} disabled={loading}>{loading ? 'Actualizando…' : 'Actualizar'}</button>
      </div>
      {error && <p role='alert'>No se pudo actualizar el uso de correo. {usage ? 'Los datos mostrados corresponden a la última consulta.' : 'Vuelve a intentarlo con Actualizar.'}</p>}
      {!usage && !error && <p role='status'>Consultando los envíos…</p>}
      {usage && <>
        <div className={Style.metrics}>
          <div><span>Enviados hoy</span><strong>{usage.accepted_today}</strong><small>Aceptados por Mailgun · Ecuador</small></div>
          <div><span>Límite diario del dominio</span><strong>{usage.daily_limit === null ? 'Sin confirmar' : usage.daily_limit}</strong><small>Último límite informado por Mailgun</small></div>
          <div><span>Puedes volver a intentar</span><strong className={Style.retry}>{retry ? formatTime(usage.retry_at) : 'Sin bloqueo registrado'}</strong><small>{retry ? 'Hora de Ecuador (UTC−5)' : 'Mailgun no ha informado una hora de reintento'}</small></div>
        </div>
        <p className={blocked ? Style.blocked : Style.note} role='status'>
          {blocked ? `Mailgun limitó los envíos. Faltan aproximadamente ${minutes} min para volver a intentar.`
            : retry ? 'La hora de reintento ya pasó. Puedes volver a intentar; Mailgun confirmará la disponibilidad.'
            : 'No hay un bloqueo de envío registrado.'}
        </p>
        <p className={Style.note}>El límite se comparte entre todas las campañas de {usage.domain}. El conteo de hoy incluye envíos de esta app desde las 00:00 de Ecuador; la ventana del proveedor puede incluir envíos del día anterior. La hora de reintento no garantiza capacidad para una campaña completa.</p>
        <small className={Style.updated}>Última consulta: {formatTime(usage.checked_at)} · Se actualiza cada minuto.</small>
      </>}
    </section>
  );
}
